import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Card, Statistic } from "antd";
import { compose } from "redux";
import { useParams } from "react-router-dom";
import Chart from "react-apexcharts";
import { loadPublisherById } from "../../../redux/actions/publisher-actions";
import { useDispatch } from "react-redux";

const gridStyle = {
    width: "25%",
    textAlign: "left",
    border: "none",
    boxShadow: "none",
};

const PrivateBuyOverview = ({ privateBuyOverviewData, publisherId, editPublisher }) => {
    const { buyType } = useParams();
    const dispatch = useDispatch();

    const [uniqueEvents, setUniqueEvents] = useState([]);
    const [uniqueEventLabels, setUniqueEventLabels] = useState([]);
    const [pieSeriesData, setPieSeriesData] = useState([]);
    const [labels, setLabels] = useState([]);

    useEffect(() => {
        if (privateBuyOverviewData) {
            if (privateBuyOverviewData.uniqueEvents) {
                setUniqueEvents(Object.keys(privateBuyOverviewData.uniqueEvents).map(item => privateBuyOverviewData.uniqueEvents[item]));
                setUniqueEventLabels(Object.keys(privateBuyOverviewData.uniqueEvents).map(item => item));
            }
            if (privateBuyOverviewData.devices) {
                setPieSeriesData(Object.keys(privateBuyOverviewData.devices).map(item => privateBuyOverviewData.devices[item]));
                setLabels(Object.keys(privateBuyOverviewData.devices).map(item => item));
            }
        }
        (async () => {
            await dispatch(loadPublisherById(publisherId));
        })();
        return () => {
            console.log("Private Buy Overview unmounting");
        };
    }, [privateBuyOverviewData]);

    const lineSeries = [{
        name: "impression.unique",
        data: uniqueEvents
    }]

    const lineOptions = {
        chart: {
            height: 350,
            type: 'line',
            zoom: {
                enabled: false
            }
        },
        markers: {
            size: 5,
            colors: '#007bff'
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 2,
            curve: 'straight',
            colors: '#007bff'
        },
        grid: {
            row: {
                colors: ['#f3f3f3', 'transparent'],
                opacity: 0.5
            },
        },
        xaxis: {
            categories: uniqueEventLabels//[new Date().toLocaleDateString().replace("/", "-").replace("/", "-")]
        }
    }

    const series = pieSeriesData;
    const options = {
        chart: {
            width: 650,
            type: 'pie',
        },
        labels: labels,
        title: {
            text: "Impressions By Device",
        }
    }

    return (
        <>
            <Row gutter={16}>
                <Col span={24}>
                    {privateBuyOverviewData ?
                        <Card
                            title="Month to date"
                            actions={[
                                <h1 style={{ textAlign: "justify", color: "#6c6f73", fontStyle: "italic", paddingLeft: "4px" }}>{`Timezone : ${editPublisher && editPublisher.timezone ? editPublisher.timezone : "unknown"}`}</h1>
                            ]}
                        >
                            <Card.Grid hoverable={false} style={{ ...gridStyle, width: "60%" }}>
                                <Card.Grid hoverable={false} style={{ ...gridStyle, width: "50%" }}>
                                    <Statistic title="Impressions" value={privateBuyOverviewData.impressionUnique != null ? privateBuyOverviewData.impressionUnique : 0} />
                                </Card.Grid>
                                <Card.Grid hoverable={false} style={{ ...gridStyle, width: "50%" }}>
                                    <Statistic title="CTR" value={privateBuyOverviewData.ctr != null ? privateBuyOverviewData.ctr : 0} precision={1} suffix="%" />
                                </Card.Grid>
                                {buyType && buyType === "display" ?
                                    <Card.Grid hoverable={false} style={{ ...gridStyle, width: "100%" }}>
                                        <Statistic title="Clicks" value={privateBuyOverviewData.clickUnique != null ? privateBuyOverviewData.clickUnique : 0} />
                                    </Card.Grid>
                                    : <>
                                        <Card.Grid hoverable={false} style={{ ...gridStyle, width: "50%" }}>
                                            <Statistic title="Completed Views" value={privateBuyOverviewData.completeUnique != null ? privateBuyOverviewData.completeUnique : 0} />
                                        </Card.Grid>
                                        <Card.Grid hoverable={false} style={{ ...gridStyle, width: "50%" }}>
                                            <Statistic title="Completion Rate" value={privateBuyOverviewData.completionRate != null ? privateBuyOverviewData.completionRate : 0} precision={1} suffix="%" />
                                        </Card.Grid>
                                    </>
                                }
                            </Card.Grid>
                            <Card.Grid hoverable={false} style={{ ...gridStyle, width: "40%" }}>
                                {privateBuyOverviewData.devices ?
                                    <Chart
                                        options={options}
                                        series={series}
                                        type="pie"
                                        style={{ padding: 0, width: "300px", margin: "auto" }}
                                    />
                                    : <Statistic title="Impressions By Device" value={"No Data"} />
                                }
                            </Card.Grid>
                        </Card>
                        : ""}
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24}>
                    {privateBuyOverviewData ?
                        <Card
                            title="Traffic"
                            actions={[
                                <h1 style={{ textAlign: "justify", color: "#6c6f73", fontStyle: "italic", paddingLeft: "4px" }}>{`Timezone : ${editPublisher && editPublisher.timezone ? editPublisher.timezone : "unknown"}`}</h1>
                            ]}
                        >
                            <Chart
                                options={lineOptions}
                                series={lineSeries}
                                type="line"
                                height={350}
                            />
                        </Card>
                        : ""}
                </Col>
            </Row>
        </>
    );
};

function mapStateToProps(state) {
    return {
        privateBuyOverviewData: state.privateBuy.privateBuyOverviewData,
        editPublisher: state.publisher.editPublisher,
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(PrivateBuyOverview);
